module.exports = __webpack_public_path__ + "img/pic7.dff446d8.png";